// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"5450":"35932e93","7420":"385458c1","9969":"8ab239fe"}[chunkId] + ".js";
};